<template>
  <footer class="footer" role="contentinfo">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>VI-GAS</h3>
          <p>Autoryzowany serwis urządzeń Viessmann</p>
          <div class="social-links">
            <a href="#" class="social-link" aria-label="Facebook VI-GAS">📘</a>
            <a href="mailto:kontakt@vi-gas.pl" class="social-link" aria-label="Wyślij email">📧</a>
            <a href="tel:+48570422020" class="social-link" aria-label="Zadzwoń do nas">📞</a>
          </div>
        </div>
        
        <nav class="footer-section" aria-label="Linki do usług">
          <h4>Usługi</h4>
          <ul>
            <li><router-link :to="{ name: 'Services' }" aria-label="Przejdź do sekcji serwis">Serwis</router-link></li>
            <li><router-link :to="{ name: 'Services' }" aria-label="Zobacz naszą ofertę">Oferta</router-link></li>
            <li><router-link :to="{ name: 'SmartHome' }" aria-label="Rozwiązania Smart Home">Smart Dom</router-link></li>
            <li><router-link :to="{ name: 'Location' }" aria-label="Zobacz naszą lokalizację">Lokalizacja</router-link></li>
          </ul>
        </nav>
        
        <address class="footer-section">
          <h4>Kontakt</h4>
          <ul>
            
            <li>📞 <a href="tel:+48570422020" aria-label="Zadzwoń: 570 422 020">+48 570 422 020</a></li>
            <li>✉️ <a href="mailto:kontakt@vi-gas.pl" aria-label="Wyślij email na kontakt@vi-gas.pl">kontakt@vi-gas.pl</a></li>
            <li><router-link :to="{ name: 'PrivacyPolicy' }" aria-label="Przejdź do polityki prywatności i cookies">Polityka prywatności i cookies</router-link></li>
            <li><button class="consent-btn" @click="manageConsents" aria-label="Zarządzaj zgodami">Zarządzaj zgodami</button></li>
          </ul>
        </address>
        
        <div class="footer-section">
          <h4>Serwis</h4>
          <ul>
            <li class="emergency">📞 <a href="tel:+48570422020" aria-label="Numer alarmowy serwisu">+48 570 422 020</a></li>
            
          </ul>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>&copy; 2025 VI-GAS Autoryzowany Serwis Viessmann. Wszelkie prawa zastrzeżone.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  methods: {
    manageConsents() {
      try {
        localStorage.removeItem('cookie_consent_v1')
        // show banner again
        window.location.reload()
      } catch (e) {
        // fallback
        console.error('Nie można zmienić ustawień cookies', e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: #1a1a1a;
  color: white;
  padding: 60px 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section {
  h3 {
    color: #FF6B35;
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  
  h4 {
    color: white;
    font-size: 1.2rem;
    margin-bottom: 20px;
  }
  
  p {
    color: #ccc;
    line-height: 1.6;
    margin-bottom: 20px;
  }
  
  ul {
    list-style: none;
    padding: 0;
    
    li {
      margin-bottom: 10px;
      color: #ccc;
      
      &.emergency {
        color: #FFD93D;
        font-weight: 600;
      }
      
      a {
        color: inherit;
        text-decoration: none;
        transition: color 0.3s ease;
        
        &:hover {
          color: #FF6B35;
        }
      }
    }
  }
}

.social-links {
  display: flex;
  gap: 15px;
  
  .social-link {
    display: inline-block;
    width: 40px;
    height: 40px;
    background: rgba(255, 107, 53, 0.1);
    border-radius: 50%;
    text-align: center;
    line-height: 40px;
    font-size: 1.2rem;
    text-decoration: none;
    transition: all 0.3s ease;
    
    &:hover {
      background: #FF6B35;
      transform: translateY(-2px);
    }
  }
}

.footer-bottom {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid #333;
  
  p {
    color: #999;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .footer {
    padding: 40px 0 20px;
  }
}
</style>